import { render, staticRenderFns } from "./dentistryFive.vue?vue&type=template&id=19f70df4&scoped=true"
import script from "./dentistryFive.vue?vue&type=script&lang=js"
export * from "./dentistryFive.vue?vue&type=script&lang=js"
import style0 from "./dentistryFive.vue?vue&type=style&index=0&id=19f70df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f70df4",
  null
  
)

export default component.exports